import { Directive } from '@angular/core';
/**
  * @name Thumbnail
  * @module ionic
  * @description
  * A Thumbnail is a component that creates a squared image for an item.
  * Thumbnails can be place on the left or right side of an item with the `item-start` or `item-end` directive.
  * @see {@link /docs/components/#thumbnail-list Thumbnail Component Docs}
 */
var Thumbnail = (function () {
    function Thumbnail() {
    }
    Thumbnail.decorators = [
        { type: Directive, args: [{
                    selector: 'ion-thumbnail'
                },] },
    ];
    /** @nocollapse */
    Thumbnail.ctorParameters = function () { return []; };
    return Thumbnail;
}());
export { Thumbnail };
//# sourceMappingURL=thumbnail.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-angular/components/thumbnail/thumbnail.js
// module id = 180
// module chunks = 1